<template>
  <div class="sw-snackbar-stack" aria-live="polite" aria-relevant="additions">
    <TransitionGroup name="sw-snackbar" tag="div" class="sw-snackbar-stack__list">
      <div
        v-for="item in items"
        :key="item.id"
        :class="['sw-snackbar', `sw-snackbar--${item.type}`]"
        role="alert"
      >
        <div class="sw-snackbar__badge" aria-hidden="true">
          <v-icon :icon="item.icon" size="18" />
        </div>

        <div class="sw-snackbar__body">
          <div class="sw-snackbar__title">{{ item.title }}</div>
          <div v-if="item.message" class="sw-snackbar__message">
            {{ item.message }}
          </div>
        </div>

        <button
          type="button"
          class="sw-snackbar__close"
          aria-label="Dismiss notification"
          @click="dismissSnackbar(item.id)"
        >
          <v-icon icon="mdi-close" size="18" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { computed } from "vue";
import { dismissSnackbar, useSnackbarState } from "@/composables/snackbar.js";

export default {
  name: "SwSnackbarHost",

  setup() {
    const state = useSnackbarState();
    const items = computed(() => state.items);

    return {
      items,
      dismissSnackbar,
    };
  },
};
</script>
